var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { childrenExist } from '../../../../lib';
import { pxToRem } from '../../utils';
var beforeAndAfter = function (color, size, variables) { return ({
    content: '""',
    flex: 1,
    height: size + 1 + "px",
    background: _.get(variables.colors, color, variables.dividerColor),
}); };
var dividerStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        var children = props.children, color = props.color, fitted = props.fitted, size = props.size, important = props.important, content = props.content;
        return __assign({ color: _.get(variables.colors, color, variables.textColor), display: 'flex', alignItems: 'center' }, (!fitted && {
            paddingTop: variables.dividerPadding,
            paddingBottom: variables.dividerPadding,
        }), (important && {
            fontWeight: variables.importantFontWeight,
        }), (childrenExist(children) || content
            ? {
                textAlign: 'center',
                fontSize: pxToRem(12 + size),
                lineHeight: variables.textLineHeight,
                '::before': __assign({}, beforeAndAfter(color, size, variables), { marginRight: pxToRem(20) }),
                '::after': __assign({}, beforeAndAfter(color, size, variables), { marginLeft: pxToRem(20) }),
            }
            : {
                '::before': __assign({}, beforeAndAfter(color, size, variables)),
            }));
    },
};
export default dividerStyles;
